import { AdvancedChart } from "react-tradingview-embed";
import { useMemo, useState, useEffect } from "react";

const TRADING_VIEW_TOOLBAR_DARK = "#2878A3";
const TRADING_VIEW_PANE_DARK = "#161616";

function toBinanceTradingViewSymbol(symbol) {
  const normalized = String(symbol || "BTCUSDT")
    .trim()
    .replace(/^[^:]+:/, "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();

  return `BINANCE:${normalized || "BTCUSDT"}`;
}

export default function TradingView({ symbol, className = "" }) {
  const [isDark, setIsDark] = useState(
    typeof document !== "undefined" &&
      document.documentElement.classList.contains("dark"),
  );
  const tradingViewSymbol = useMemo(
    () => toBinanceTradingViewSymbol(symbol),
    [symbol],
  );

  useEffect(() => {
    if (typeof document === "undefined") return;

    const html = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsDark(html.classList.contains("dark"));
    });

    observer.observe(html, { attributes: true, attributeFilter: ["class"] });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className={`w-full h-full rounded-2xl [clip-path:inset(2px)] overflow-hidden bg-zi-bg2-light dark:bg-zi-bg2-dark ${className}`}
    >
      <AdvancedChart
        key={tradingViewSymbol}
        widgetProps={{
          symbol: tradingViewSymbol,
          theme: isDark ? "dark" : "light",
          backgroundColor: isDark ? TRADING_VIEW_PANE_DARK : "",
          interval: "D", // 1 day candles
          style: "1",
          timezone: "Asia/Tehran",
          toolbar_bg: isDark ? TRADING_VIEW_TOOLBAR_DARK : "#FFFFFF",
          withdateranges: false,
          autosize: false,
          height: "100%",
          overrides: isDark
            ? {
                "paneProperties.background": TRADING_VIEW_PANE_DARK,
                "paneProperties.backgroundType": "solid",
                "paneProperties.vertGridProperties.color": "#253540",
                "paneProperties.horzGridProperties.color": "#253540",
              }
            : undefined,
        }}
      />
    </div>
  );
}
